import React from 'react';
import classNames from 'classnames';

import './styles.css';

export default function LoadingBar({ className }) {
  return (
    <div className={classNames('LoadingBar', className)}>
      <div className="LoadingBar_line"></div>
      <div className="LoadingBar_subline LoadingBar_inc"></div>
      <div className="LoadingBar_subline LoadingBar_dec"></div>
    </div>
  );
}
